import _ from 'underscore';
import React, { useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import { filterQuery } from '@culture/common-helpers/url';
import { useRouter } from 'next/router';
import {
	BreadcrumbsPropType,
	MetaPropType,
	NavigationPropType,
	PaginationPropType,
	PromoBlockPropType
} from 'propTypes/common';
import Container from 'components/Container';
import { Layout, LayoutBlock } from 'components/Layout';

import CatalogTitleHeading from 'components/CatalogTitleHeading';

import Breadcrumbs from 'components/Breadcrumbs';

import SectionCategories from 'components/catalogs/SectionCategories';
import Catalog from './components/Catalog';
import Filters from './components/Filters';

import styles from './styles.module.scss';

const MusicalGroupsTemplate = ({
	defaultUrlParams,
	collectives,
	menu,
	meta,
	breadcrumbs,
	urlParams,
	federalSubjects,
	topPromoBlock,
	rubric
}) => {
	const { total } = collectives;
	const { name: rubricName, rootRubricPath } = rubric;

	const { push, pathname } = useRouter();
	const contentContainerRef = useRef(null);

	const changeUrl = (params) => {
		const filterParams = filterQuery(
			_(params).pick('query', 'sort', 'cleanCache')
		);
		push({
			pathname: `/${rootRubricPath}`,
			query: filterParams
		});
	};

	const handleFilterChange = useCallback(
		(name, value) => {
			const currentValue = urlParams[name] || '';
			if (value !== currentValue) {
				const params = {
					...urlParams,
					[name]: value,
					page: null
				};

				changeUrl(params);
			}
		},
		[urlParams]
	);

	const handleFilterReset = () => {
		const resetPath = `/${rootRubricPath}`;
		push({ pathname: resetPath });
	};

	const emptyMessage =
		'К сожалению, музыкальных коллективов по вашему запросу не найдено';

	return (
		<>
			<Layout {...{ menu, meta, topPromoBlock }}>
				<SectionCategories
					federalSubjects={federalSubjects}
					rubricName={rubricName}
					showAccessibilityCard={false}
				/>
				<LayoutBlock gutter="none">
					<Container>
						<Breadcrumbs
							items={breadcrumbs}
							currentPath={pathname}
							showAllItems
						/>
					</Container>
				</LayoutBlock>
				<LayoutBlock
					gutter="mediumConstant"
					ref={contentContainerRef}
					className={styles.Content}
				>
					<Container innerClassName={styles.Title}>
						<CatalogTitleHeading
							{...{ headingTitle: meta?.headingTitle, total }}
						/>
					</Container>
				</LayoutBlock>
				<LayoutBlock gutter="mediumConstant">
					<Container>
						<Filters
							{...{
								urlParams,
								defaultUrlParams,
								rootRubricPath,
								handleFilterChange,
								handleFilterReset
							}}
							showSortFilter
						/>
					</Container>
				</LayoutBlock>
				<LayoutBlock>
					<Container>
						<div className={styles.Catalog}>
							<Catalog {...{ collectives, emptyMessage }} />
						</div>
					</Container>
				</LayoutBlock>
			</Layout>
		</>
	);
};

MusicalGroupsTemplate.propTypes = {
	defaultUrlParams: PropTypes.object.isRequired,
	collectives: PropTypes.shape({
		pagination: PaginationPropType.isRequired,
		total: PropTypes.number.isRequired,
		items: PropTypes.array.isRequired
	}),
	menu: NavigationPropType.isRequired,
	meta: MetaPropType.isRequired,
	breadcrumbs: BreadcrumbsPropType,
	urlParams: PropTypes.object.isRequired,
	federalSubjects: PropTypes.array,
	topPromoBlock: PromoBlockPropType,
	rubric: PropTypes.shape({
		rootRubricPath: PropTypes.string,
		name: PropTypes.string
	})
};

export default MusicalGroupsTemplate;
